import { useCallback, useEffect, useState } from 'react';
import { fileResCommunication } from '../../type';
import { UpdateTabProps } from './index';
import { SIZE_PAGE_COMMUNICATION } from 'const/paging';
import { getSeizureReportCommunication, updateSeizureReport } from 'services/communication';
import { useSearchParams } from 'react-router-dom';
import { useAsyncCallback } from 'hooks/useAsyncCallback';

export const useInjection = ({
  initData,
  dateSearch,
  onRefreshTabSeizureReport
}: Partial<UpdateTabProps>) => {
  const [dataRow, setDataRow] = useState<fileResCommunication[]>([]);
  const [page, setPage] = useState<number>(1);
  const [searchParams] = useSearchParams();
  const [hasMore, setHasMore] = useState<boolean>(false);
  const [dataClientSelected, setDataClientSelected] = useState<fileResCommunication | undefined>(
    undefined
  );
  useEffect(() => {
    if (!initData) {
      setDataRow([]);
      return;
    }
    setDataClientSelected(undefined);
    setDataRow(initData.updates);
    if (initData.total > SIZE_PAGE_COMMUNICATION) {
      setHasMore(true);
      setPage(2);
      return;
    }
  }, [initData]);
  const [loading, setLoading] = useState(false);

  const fetchMoreData = useCallback(async () => {
    if (loading || !hasMore) return;
    setLoading(true);
    try {
      const res = await getSeizureReportCommunication({
        page,
        size: SIZE_PAGE_COMMUNICATION,
        endDate: dateSearch?.endDate,
        startDate: dateSearch?.startDate
      });
      const newData = res.updates;
      setDataRow((prevState) => [...prevState, ...newData]);
      setHasMore(res.total > SIZE_PAGE_COMMUNICATION * page);
      setPage((prevState) => prevState + 1);
      setHasMore(false);
    } catch (e) {
      setHasMore(false);
    } finally {
      setLoading(false);
    }
  }, [loading, hasMore, page, dateSearch?.endDate, dateSearch?.startDate]);

  useEffect(() => {
    setDataClientSelected(undefined);
  }, [searchParams.get('tab')]);

  const { asyncCallback: asyncHandleDeleteReport } = useAsyncCallback(
    useCallback(
      async (id: number, fileId: number) => {
        await updateSeizureReport(id, { hiddenCommunication: true });
        setDataRow((prevState) =>
          prevState.map((item) => {
            if (item.id === fileId) {
              return {
                ...item,
                seizureReports: item.seizureReports?.filter((itemReport) => itemReport.id !== id)
              };
            }
            return item;
          })
        );
        onRefreshTabSeizureReport && onRefreshTabSeizureReport();
      },
      [onRefreshTabSeizureReport]
    ),
    []
  );

  return {
    dataRow,
    hasMore,
    fetchMoreData,
    dataClientSelected,
    setDataClientSelected,
    handleDeleteReport: asyncHandleDeleteReport
  };
};
